var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[(_vm.is_changed)?_c('button',{staticClass:"btn btn-info ml-auto",class:{ 'mt-1': !_vm.appended },attrs:{"title":_vm.value_is_changed_text},on:{"click":function($event){return _vm.revert()}}},[_c('span',[_vm._v(_vm._s(_vm._f("t")('change_back')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }